import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './views/home/home.component';
import { AboutComponent } from './views/about/about.component';
import { DetailsComponent } from './views/details/details.component';
// import { ListComponent } from './views/list/list.component';
// import { PublicacoesComponent } from './views/publicacoes/publicacoes.component';
// import { ExtrasComponent } from './views/extras/extras.component';

const routes: Routes = [  {
  path: "",
  redirectTo: '/home',
  pathMatch: 'full'
},{
  path: 'home',
  component: HomeComponent
},{
    path: 'abertura',
    component: HomeComponent
  },{
  path: 'sobre',
  component: DetailsComponent
},{
  path: 'dramaturgos/:alias',
  component: HomeComponent
},{
  path: 'dramaturgos/:alias/sobre',
  component: DetailsComponent
},{
  path: '**',
  redirectTo: '/home'
}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
